module.exports = __webpack_public_path__ + "static/media/execute_PP1.9356e90b.png";